var map = {
	"./character1.png": 64,
	"./character2.png": 65,
	"./character3.png": 66,
	"./character4.png": 67,
	"./character5.png": 68,
	"./character6.png": 69,
	"./character7.png": 70,
	"./character8.png": 71,
	"./character9.png": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;